import { useBFFWebChatState } from './useBFFWebChatState';
export function useBFFStyleOptions() {
    const [state] = useBFFWebChatState();
    return state.styleOptions;
}
//# sourceMappingURL=useBFFStyleOptions.js.map